export interface ActivityActor {
    type: 'agent' | 'user';
    name?: string;
}

export interface ActivityEntry {
    id: string;
    actor: ActivityActor;
    title: string;
    description?: string;
    timeLabel: string;
    /**
     * REV-21869 (#165) — the trail's own classification (OK | ATTENTION | AI_FINDING), rendered
     * as `data-kind`. Absent for entries that carry no trail origin (a comment, a pendency) — a
     * required field defaulting to `OK` would mark every entry in the world as reviewed.
     */
    kind?: 'OK' | 'ATTENTION' | 'AI_FINDING';
    /** Formatted amount (e.g. "0.00", "295.01") — only set together with `derivationId` (B2-8). */
    amountLabel?: string;
    derivationId?: string;
    /** REV-22302 — the AI entry's raw codes and parameters, shown as they come. */
    rawDetail?: string;
}
